var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewOfferClear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.453,
    height: 16.921,
    viewBox: "0 0 29.453 16.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_69456",
    "data-name": "Raggruppa 69456",
    transform: "translate(-166.045 -250.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37241",
    "data-name": "Tracciato 37241",
    d: "M124.721,148.277l-2.266-14.136a.648.648,0,0,0-.648-.544H98.227a.648.648,0,0,0-.673.531l-2.234,12.9a1.942,1.942,0,0,0,1.913,2.267h2.836a1.944,1.944,0,0,0,1.8,1.224H122.8a1.943,1.943,0,0,0,1.917-2.25Zm-27.977-.5a.648.648,0,0,1-.149-.534l1.619-9.3,1.619,10.037h-2.59a.648.648,0,0,1-.5-.207Z",
    transform: "translate(70.752 117.401)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37274",
    "data-name": "Tracciato 37274",
    d: "M134.038,165.868h-2.709a.766.766,0,0,1-.564-.226.738.738,0,0,1-.188-1.053.49.49,0,0,1,.489-.188h2.709l-.489-2.709a.646.646,0,0,1,.451-.752h.15a.929.929,0,0,1,.9.752v.038l.489,2.633h2.671a.888.888,0,0,1,.865.752.615.615,0,0,1-.451.752c-.075,0-.113.038-.188,0H135.5l.489,2.709a.653.653,0,0,1-.113.527.727.727,0,0,1-1.053,0,1.072,1.072,0,0,1-.3-.527Z",
    transform: "translate(47.157 94.323)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewOfferClear);
export default __webpack_public_path__ + "static/media/new-offer-clear.ec4d76b2c4d04f3e6833578ed450cab4.svg";
export { ForwardRef as ReactComponent };